import React, { useContext } from "react";
import ApplicatonContext from "../../../context/index";
import AutoSuggest from "../../../components/common/autoSuggest";
// import ChipSelect from "../../../components/common/chipSelectHook";
import FieldLabel from "../../../components/common/label";
import ImageUpload from "../../../components/common/upload";
import withStyles from "@material-ui/core/styles/withStyles";
import { Box, Grid, Hidden, TextField, Typography } from "@material-ui/core";
import { useStyles } from "../indexFormStyles";
import {
  // buildTimeslots,
  getPreferredMinDate,
  getPreferredMaxDate,
  // isValidDate,
} from "../../../helpers/date";
import { renderServiceCentreAddress } from "../../../helpers/utils";
import renderHTML from "react-render-html";

function VehicleDetailsForm(props) {
  const {
    state: { orderDetails = null, makes = [], models = [], variants = [] },
  } = useContext(ApplicatonContext);
  const {
    classes: { formGroup, gutterTop, question, textField },
    changeOptionBaseOnValue,
    errorMessage,
    form,
    handleAutocompleteChange,
    handleChange,
    // handleChangeChipSelect,
    isManufacturerChanged,
    isManufacturerVisible,
    isModelChanged,
    isModelVisible,
    isVariantVisible,
    isSearchCompleted,
    photoChangeHandler,
  } = props;

  return (
    isSearchCompleted && (
      <Box direction="column" style={{ width: "100%" }} sx={{ textAlign: 'left' }}>
        <Grid container spacing={2} className={!orderDetails ? "disabled" : ""}>
          <Grid container item md={5} direction="column">
            <Box className={formGroup}>
              <FieldLabel label={"Damage Date"} labelKey={"damage_date"} />
              <Box className={gutterTop}>
                <TextField
                  type={"date"}
                  id="outlined-margin-none"
                  name="damage_date"
                  className={textField}
                  helperText={errorMessage.damage_date}
                  variant="outlined"
                  value={form.damage_date}
                  onChange={handleChange}
                  inputProps={{
                    // min: getPreferredMinDate(),
                    max: getPreferredMinDate(),
                    onKeyDown: (e) => e.preventDefault()
                  }}
                />
              </Box>
            </Box>
          </Grid>

          <Hidden smDown>
            <Grid container item md={2} direction="column"></Grid>
          </Hidden>

          <Grid container item md={5} direction="column">
            <Box className={formGroup}>
              <FieldLabel label={"Your State"} />
              <Box className={gutterTop}>
                {isManufacturerVisible ? (
                  <AutoSuggest
                    id={"controllable-state"}
                    handleChange={handleAutocompleteChange}
                    label={"Select State"}
                    options={makes}
                    option={{
                      title: "",
                      value: "",
                    }}
                    field={"state_id"}
                    changeOptionBaseOnValue={changeOptionBaseOnValue}
                  />
                ) : (
                  <TextField
                    type={"text"}
                    id="outlined-margin-none"
                    name="state_id"
                    variant="outlined"
                    className={textField}
                    value={form.state_id}
                    onChange={handleChange}
                    {...{ disabled: true }}
                  />
                )}
                {errorMessage.state_id && (
                  <Typography
                    component={"p"}
                    variant={"string"}
                    paragraph={true}
                    className="error-message"
                  >
                    {errorMessage.state_id}
                  </Typography>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Grid container spacing={2} className={!orderDetails ? "disabled" : ""}>

          <Grid container item md={5} direction="column">
            <Box className={formGroup}>
              <FieldLabel
                label={"How did the phone get damaged? (Minimum 60 characters)"}
                fieldValue={""}
                labelKey={"damage_details"}
                asterisk={false}
              />
              <TextField
                type={"text"}
                id="outlined-margin-none"
                name="damage_details"
                className={textField}
                helperText={errorMessage.damage_details}
                value={form.damage_details}
                onChange={handleChange}
                variant={"outlined"}
                multiline
                minRows={8}
              />
            </Box>
          </Grid>

          <Hidden smDown>
            <Grid container item md={2} direction="column"></Grid>
          </Hidden>

          <Grid container item md={5} direction="column">
            <Box className={formGroup}>
              <FieldLabel label={"Your City"} />
              <Box className={gutterTop}>
                {isModelVisible ? (
                  <AutoSuggest
                    id={"controllable-city"}
                    handleChange={handleAutocompleteChange}
                    label={"Select City"}
                    options={models}
                    option={{
                      title: isManufacturerChanged ? "" : form?.city_id,
                      value: isManufacturerChanged ? "" : form?.city_id,
                    }}
                    field={"city_id"}
                    disabled={!form.state_id}
                  />
                ) : (
                  <TextField
                    type={"text"}
                    id="outlined-margin-none"
                    name="city_id"
                    variant="outlined"
                    className={textField}
                    value={form.city_id}
                    onChange={handleChange}
                    {...{ disabled: true }}
                  />
                )}
                {errorMessage.city_id && (
                  <Typography
                    component={"p"}
                    variant={"string"}
                    paragraph={true}
                    className="error-message"
                  >
                    {errorMessage.city_id}
                  </Typography>
                )}
              </Box>
            </Box>


            <Box className={formGroup}>
              <FieldLabel label={"Preferred Service Centre"} />
              <Box className={gutterTop}>
                {isVariantVisible ? (
                  <AutoSuggest
                    id={"controllable-service-centre"}
                    handleChange={handleAutocompleteChange}
                    label={"Select Service Centre"}
                    options={variants}
                    option={{
                      title: isModelChanged ? "" : form?.service_centre_id,
                      value: isModelChanged ? "" : form?.service_centre_id,
                    }}
                    field={"service_centre_id"}
                    disabled={!form.city_id}
                    isCustomized={true}
                  />
                ) : (
                  <TextField
                    type={"text"}
                    id="outlined-margin-none"
                    name="service_centre_id"
                    variant="outlined"
                    className={textField}
                    value={form.service_centre_id}
                    onChange={handleChange}
                    {...{ disabled: true }}
                  />
                )}
                {errorMessage.service_centre_id && (
                  <Typography
                    component={"p"}
                    variant={"string"}
                    paragraph={true}
                    className="error-message"
                  >
                    {errorMessage.service_centre_id}
                  </Typography>
                )}
              </Box>
              {form.service_centre_id && (
                <Box mt={1} m={1} textAlign={"left"}>
                  <small>
                    Address: <br />
                    {renderHTML(
                      renderServiceCentreAddress(
                        form.service_centre_id,
                        variants
                      )
                    )}
                  </small>
                </Box>
              )}
            </Box>

          </Grid>

          
        </Grid>

        <Grid container spacing={2} className={!orderDetails ? "disabled" : ""}>
        <Grid container item md={5} direction="column">
            <Box className={formGroup}>
              <FieldLabel
                label={"Damage Phone Photo  (Optional)"}
                fieldValue={""}
                required={false}
              />
              <ImageUpload
                title="Add"
                photoChangeHandler={photoChangeHandler}
                filename="phone"
              />
            </Box>
          </Grid>

          <Hidden smDown>
            <Grid container item md={2} direction="column"></Grid>
          </Hidden>

          <Grid container item md={5} direction="column">
            <Box className={formGroup}>
              <FieldLabel
                label={"Date to visit service centre"}
                labelKey={"preferred_date"}
              />
              <Box className={gutterTop}>
                <TextField
                  type={"date"}
                  id="outlined-margin-none"
                  name="preferred_date"
                  className={textField}
                  helperText={errorMessage.preferred_date}
                  variant="outlined"
                  value={form.preferred_date}
                  onChange={handleChange}
                  inputProps={{
                    min: getPreferredMinDate(),
                    max: getPreferredMaxDate(),
                    onKeyDown: (e) => e.preventDefault()
                  }}
                />
              </Box>
            </Box>
          </Grid>

          
        </Grid>

        {/* <Grid container spacing={2} className={!orderDetails ? "disabled" : ""}>
          <Grid container item md={12} direction="column">
            <Box className={formGroup}>
              <FieldLabel label={"Preferred Timeslot"} />
              {form.preferred_date && isValidDate(form.preferred_date) ? (
                <ChipSelect
                  compact={false}
                  fontWeight={"regular"}
                  fieldname={"preferred_timeslot"}
                  handleChangeChipSelect={handleChangeChipSelect}
                  options={buildTimeslots(form.preferred_date)}
                  selectedItem={form.title}
                />
              ) : (
                <Box m={1}>
                  <Typography variant="body2" className="error-message">
                    No Timeslot Available.
                  </Typography>
                </Box>
              )}
            </Box>
          </Grid>
        </Grid> */}
      </Box>
    )
  );
}

export default withStyles(useStyles, { withTheme: true })(VehicleDetailsForm);
